<template>
  <transition name="fade-info">
    <template v-if="isNotificationActive">
      <div class="notification-wrap notification-item-empty" v-if="showMainCount == 0 && showInboxCount === 0">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                <path d="M15 0.299805C6.99263 0.299805 0.5 6.79244 0.5 14.7998C0.5 22.8072 6.99263 29.2998 15 29.2998C23.0074 29.2998 29.5 22.8072 29.5 14.7998C29.5 6.79244 23.0074 0.299805 15 0.299805ZM15 26.84C8.35201 26.84 2.95982 21.4478 2.95982 14.7998C2.95982 11.9192 3.97288 9.27168 5.66239 7.20025L22.5996 24.1374C20.5281 25.8269 17.8806 26.84 15 26.84ZM24.3376 22.3994L7.40045 5.46219C9.47188 3.77268 12.1194 2.75963 15 2.75963C21.648 2.75963 27.0402 8.15181 27.0402 14.7998C27.0402 17.6804 26.0271 20.3279 24.3376 22.3994Z" fill="#9BA1AB"/>
            </svg>
            <p class="notification-empty-text">
                {{ $t("You don't have any notifications yet") }}
            </p>
      </div>
      <div v-else class="notification-wrap notification-desktop-container" @click="closeMobileSettings">
        <div class="notification-top">
          <div class="notification-header">
            <div class="notification-header__title" >
              <span class="notification-close" v-if="mobile" type="button" @click="$emit('close-notify')">
                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.00982 12.1902C8.00982 11.9393 8.10562 11.6884 8.29683 11.4971L14.3166 5.47738C14.6995 5.09445 15.3204 5.09445 15.7032 5.47738C16.0859 5.86016 16.0859 6.48089 15.7032 6.86386L10.3765 12.1902L15.703 17.5165C16.0857 17.8994 16.0857 18.5201 15.703 18.9028C15.3202 19.286 14.6993 19.286 14.3164 18.9028L8.29664 12.8832C8.10541 12.6919 8.00982 12.441 8.00982 12.1902Z" fill="#1F1F1F"/>
                </svg>
              </span>
              <h3 class="notification-title">
                {{ $t("Notifications") }}
              </h3>
            </div>
            <div class="notification-settings mobile" v-if="mobile">
                <button class="notification-open-settings" type="button" data-notification-id="2" @click.prevent.stop="mobileSettingsNotify">
                    <img src="/img/header/options.svg" alt="options" width="24" height="24">
                </button>
                <ul class="notification-list-settings" v-show="mobileSettingsActive" @click.stop>
                    <li>
                        <a href="/account/preferences">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25"
                                fill="none">
                                <path
                                    d="M19.7134 12.5C19.7134 12.27 19.7031 12.05 19.6826 11.82L21.5955 10.41C22.0069 10.11 22.12 9.55 21.8629 9.11L19.9397 5.88C19.8164 5.66818 19.6169 5.50814 19.3796 5.43062C19.1423 5.3531 18.884 5.36356 18.6541 5.46L16.4429 6.37C16.0624 6.11 15.6613 5.88 15.2396 5.69L14.9414 3.38C14.8797 2.88 14.4374 2.5 13.9232 2.5H10.0871C9.56256 2.5 9.12032 2.88 9.05861 3.38L8.76036 5.69C8.33869 5.88 7.93759 6.11 7.55706 6.37L5.34588 5.46C4.87279 5.26 4.31742 5.44 4.06031 5.88L2.13709 9.12C1.87998 9.56 1.99311 10.11 2.40449 10.42L4.31742 11.83C4.27479 12.279 4.27479 12.731 4.31742 13.18L2.40449 14.59C1.99311 14.89 1.87998 15.45 2.13709 15.89L4.06031 19.12C4.31742 19.56 4.87279 19.74 5.34588 19.54L7.55706 18.63C7.93759 18.89 8.33869 19.12 8.76036 19.31L9.05861 21.62C9.12032 22.12 9.56256 22.5 10.0768 22.5H13.9129C14.4272 22.5 14.8694 22.12 14.9311 21.62L15.2294 19.31C15.651 19.12 16.0521 18.89 16.4327 18.63L18.6438 19.54C19.1169 19.74 19.6723 19.56 19.9294 19.12L21.8526 15.89C22.1097 15.45 21.9966 14.9 21.5852 14.59L19.6723 13.18C19.7031 12.95 19.7134 12.73 19.7134 12.5ZM12.0411 16C10.0562 16 8.44154 14.43 8.44154 12.5C8.44154 10.57 10.0562 9 12.0411 9C14.0261 9 15.6407 10.57 15.6407 12.5C15.6407 14.43 14.0261 16 12.0411 16Z" />
                            </svg>
                            {{ $t("Settings") }}
                        </a>
                    </li>
                    <li>
                        <a href="/notification/read-all" @click.prevent="readAll" class="read-all mobile-read">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="13" viewBox="0 0 20 13"
                                fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M19.6517 0.731802C20.0623 1.08536 20.1178 1.71593 19.7756 2.1402L11.711 12.1401C11.3943 12.5328 10.8421 12.6155 10.4306 12.3319L9.46315 11.6653C9.01848 11.3588 8.8984 10.738 9.19494 10.2785C9.49149 9.819 10.0924 9.69492 10.537 10.0013L10.7809 10.1694L18.2887 0.859839C18.6309 0.435564 19.2411 0.37824 19.6517 0.731802Z" />
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M14.4907 0.731802C14.9013 1.08536 14.9568 1.71593 14.6146 2.1402L6.54999 12.1401C6.37592 12.356 6.12201 12.4862 5.85039 12.4989C5.57877 12.5117 5.31449 12.4057 5.12223 12.2071L0.283449 7.20709C-0.0944831 6.81657 -0.0944831 6.18341 0.283449 5.79289C0.661381 5.40237 1.27413 5.40237 1.65206 5.79289L5.7415 10.0186L13.1277 0.859839C13.4699 0.435564 14.0801 0.37824 14.4907 0.731802Z" />
                            </svg>
                            {{ $t("Mark all as read") }}
                        </a>
                    </li>
                </ul>
            </div>
            <div class="notification-read" v-else>
                <a class="options" href="/notification/index">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25"
                        viewBox="0 0 24 25" fill="currentColor">
                        <path d="M19.7134 12.5C19.7134 12.27 19.7031 12.05 19.6826 11.82L21.5955 10.41C22.0069 10.11 22.12 9.55 21.8629 9.11L19.9397 5.88C19.8164 5.66818 19.6169 5.50814 19.3796 5.43062C19.1423 5.3531 18.884 5.36356 18.6541 5.46L16.4429 6.37C16.0624 6.11 15.6613 5.88 15.2396 5.69L14.9414 3.38C14.8797 2.88 14.4374 2.5 13.9232 2.5H10.0871C9.56256 2.5 9.12032 2.88 9.05861 3.38L8.76036 5.69C8.33869 5.88 7.93759 6.11 7.55706 6.37L5.34588 5.46C4.87279 5.26 4.31742 5.44 4.06031 5.88L2.13709 9.12C1.87998 9.56 1.99311 10.11 2.40449 10.42L4.31742 11.83C4.27479 12.279 4.27479 12.731 4.31742 13.18L2.40449 14.59C1.99311 14.89 1.87998 15.45 2.13709 15.89L4.06031 19.12C4.31742 19.56 4.87279 19.74 5.34588 19.54L7.55706 18.63C7.93759 18.89 8.33869 19.12 8.76036 19.31L9.05861 21.62C9.12032 22.12 9.56256 22.5 10.0768 22.5H13.9129C14.4272 22.5 14.8694 22.12 14.9311 21.62L15.2294 19.31C15.651 19.12 16.0521 18.89 16.4327 18.63L18.6438 19.54C19.1169 19.74 19.6723 19.56 19.9294 19.12L21.8526 15.89C22.1097 15.45 21.9966 14.9 21.5852 14.59L19.6723 13.18C19.7031 12.95 19.7134 12.73 19.7134 12.5ZM12.0411 16C10.0562 16 8.44154 14.43 8.44154 12.5C8.44154 10.57 10.0562 9 12.0411 9C14.0261 9 15.6407 10.57 15.6407 12.5C15.6407 14.43 14.0261 16 12.0411 16Z" fill="currentColor"/>
                    </svg>
                    {{ $t("Options") }}
                </a>
            </div>
          </div>
          <div class="notification-tabs__wrap" v-if="showMainCount > 0 && showInboxCount > 0"> 
            <div class="notification-tabs__item">
              <ul class="nav nav-tabs notification-tabs tabs-indicator-notification">
                <span class="indicator" :class="activeTab"></span>
                <li class="nav-pill notification-tabs-item" :class="{active: activeTab == 'main'}" @click.prevent="changeTab('main')">
                    <a class="nav-tabs-link notification-tabs-link" href="#main" role="tab"
                        data-toggle="tab">
                        <h5 class="notification-tabs-title" aria-controls="pending">{{ $t("Main") }}</h5>
                        <span v-show="mainCount > 0" class="count count-bg" aria-controls="pending">{{ mainCount }}</span>
                    </a>
                </li>
                <li class="nav-pill notification-tabs-item" :class="{active: activeTab == 'inbox'}" @click.prevent="changeTab('inbox')">
                    <a class="nav-tabs-link notification-tabs-link" href="#inbox" role="tab"
                        data-toggle="tab">
                        <h5 class="notification-tabs-title">{{ $t("Inbox") }}</h5>
                        <span v-show="inboxCount > 0" class="count count-bg">{{inboxCount}}</span>
                    </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div v-if="showMainCount > 0" class="notification-body" v-show="activeTab === 'main'" :class="{'active': activeTab === 'main'}"
              id="main" data-group="2">
            <ScrollFade class="notification-body-content" fade-top-class="faded-top" fade-bottom-class="faded" v-if="mainMessages">
              <NotificationMessage
                  :messages="mainMessages"
                  :language="language"
                  @mouse-enter="mouseEnterNotify"
                  @remove-notify="removeNotify"
                />
            </ScrollFade>
            <div class="notification-alert-mark"
              :class="{active: notificationAlertMark && activeTab === 'main'}"
              v-if="alertMarkMain">
                <p>
                    {{ $t("All messages marked as read") }}
                </p>
            </div>
        </div>
        <div v-show="activeTab === 'inbox'" class="notification-body" v-if="showInboxCount > 0"
            :class="{'active': activeTab === 'inbox'}"
            id="inbox" data-group="2">
            <ScrollFade class="notification-body-content" fade-top-class="faded-top" fade-bottom-class="faded" v-if="inboxMessages">
              <NotificationMessage
                :messages="inboxMessages"
                :language="language"
                @mouse-enter="mouseEnterNotify"
                @remove-notify="removeNotify"
              />
            </ScrollFade>
            <div class="notification-alert-mark" :class="{active: notificationAlertMark && activeTab === 'inbox'}"  v-if="alertMarkInbox">
                <p>
                    {{ $t("All messages marked as read") }}
                </p>
            </div>
        </div>
        <div class="notification-footer">
          <a href="#" class="read-all" @click.prevent="readAll" v-if="!mobile">
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 13.1998L7.143 16.7998L15 7.7998M20 7.8628L11.428 16.8628L11 16.2998" stroke="#505050" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              {{ $t("Mark all as read") }}
          </a>
          <a class="btn-hover btn-hover--gray show-all" :class="{'btn-preloader-link': isBtnPreloader}" @click="togglePreloader('btn')"
                :href="`/${language}/notification/index#info__notifications`">
              <span>{{ $t("See All Notifications") }}</span>
              <svg width="20" height="21" viewBox="0 0 20 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.317 10.0417C13.317 10.2508 13.2372 10.4598 13.0778 10.6193L8.06136 15.6357C7.74225 15.9548 7.22487 15.9548 6.90589 15.6357C6.58691 15.3167 6.58691 14.7994 6.90589 14.4803L11.3447 10.0417L6.90605 5.60307C6.58707 5.28396 6.58707 4.76673 6.90605 4.44778C7.22503 4.12852 7.74241 4.12852 8.06152 4.44778L13.078 9.46412C13.2373 9.62361 13.317 9.83267 13.317 10.0417Z" fill="currentColor"/>
              </svg>
          </a>
        </div>
      </div>
    </template>
  </transition>
</template>
  
  <script>
import TabsIndicator from '/webpack-assets/vue/components/TabsIndicator.vue';
import ScrollFade from '/webpack-assets/vue/components/ScrollFade.vue';
import NotificationMessage from './NotificationMessage.vue';
import axios from '/webpack-assets/vue/config/axios-config';

  export default {
    name: 'Notifications',
    emits: ['close-notify', 'count-notification'],
    components: {
      TabsIndicator,
      NotificationMessage,
      ScrollFade
    },
    props: {
        mobile: {
            type: Boolean,
            default: false,
        },
        tablet: {
            type: Boolean,
            default: false,
        },
        isNotificationActive: {
          type: Boolean,
          default: false,
        },
        language: {
            type: String,
            default: 'en',
        },
        notificationData: {
          type: Object,
          default: () => {},
        }
    },
    data() {
      return {
        mainMessages: this.notificationData?.main_notifications,
        inboxMessages: this.notificationData?.inbox_notifications,
        mainCount: this.notificationData?.main_count_unread,
        showMainCount: this.notificationData?.shown_main_count,
        inboxCount: this.notificationData?.inbox_count_unread,
        showInboxCount: this.notificationData?.shown_inbox_count,
        activeTab: this.notificationData?.shown_main_count > 0 ? 'main' : 'inbox',
        isSettingsPreloader: false,
        isBtnPreloader: false,
        notificationAlertMark: false,
        mobileSettingsActive: false,
        alertFooterOpen: false,
        alertMarkMain: true,
        alertMarkInbox: true,
        tabs: [
          { name: this.$t('Main'), id: 'main', count: this.notificationData?.shown_main_count, isShow: this.notificationData?.shown_main_count > 0 },
          { name: this.$t('Inbox'), id: 'inbox', count: this.notificationData?.shown_inbox_count, isShow: this.notificationData?.shown_inbox_count > 0 },
        ],
      };
    },
    methods: {
      mouseEnterNotify(id) {
        axios.get('/' + this.language + '/notification/read/' + id)
        .then(response => {
          if(response.data.success === 1) {
            const messages = this.activeTab === 'main' ? this.mainMessages : this.inboxMessages;

            const msg = messages.find(msg => msg.id === id);
            if (msg) msg.status = 1;

            this.mainCount = response.data.main_count_unread;
            this.inboxCount = response.data.inbox_count_unread;
            this.$emit('count-notification', response.data.count_unread);
          }
        })
        .catch(error => {
            console.error('Error response:', error);
        });
      },
      changeTab(tab) {
        this.activeTab = tab;
      },
      readAll() {
        axios.get('/' + this.language + '/notification/read-all')
        .then(response => {
          if(response.data.success === 1) {
          
            this.mainCount = response.data.main_count_unread;
            this.inboxCount = response.data.inbox_count_unread;
            this.$emit('count-notification', response.data.count_unread);

            const handleAlert = (alertMark, setAlertMark) => {
                if (alertMark) {
                    this.alertFooterOpen = true;
                    this.notificationAlertMark = true;
                    setTimeout(() => {
                        this.alertFooterOpen = false;
                        this.notificationAlertMark = false;
                        setTimeout(() => {
                            setAlertMark(false);
                        }, 500);
                    }, 1500);
                }
            };
            if (this.activeTab === 'main') {
              handleAlert(this.alertMarkMain, (value) => (this.alertMarkMain = value));
            } else {
              handleAlert(this.alertMarkInbox, (value) => (this.alertMarkInbox = value));
            }
          }
        })
        .catch(error => {
            console.error('Error response:', error);
        });
      },
      removeNotify(msgId, mainCount, inboxCount, countUnread) {
          if (this.activeTab === 'main') {
              this.mainMessages = this.mainMessages.filter(msg => msg.id !== msgId)
          } else {
              this.inboxMessages = this.inboxMessages.filter(msg => msg.id !== msgId)
          }

          this.mainCount = mainCount;
          this.inboxCount = inboxCount;
          this.$emit('count-notification', countUnread);
      },
      togglePreloader(btn) {
        if(btn === 'settings') {
          this.isSettingsPreloader = true;
        } else {
          this.isBtnPreloader = true;
        }
        
      },
      handleTabChange(tabId) {
        this.activeTab = tabId;
      },
      closeMobileSettings() {
        if (this.mobileSettingsActive) {
          this.mobileSettingsActive = false;
        }
      },
      mobileSettingsNotify() {
        this.mobileSettingsActive = !this.mobileSettingsActive;
      }
    },
  };
</script>

<style lang="scss">
.notification-wrap{
  .notification-tabs-wrap{
    @media only screen and (max-width: 767px) {
      border-radius: 4px;
      background-color: #252E3D;
      padding: 5px;
      margin-top: 20px;
    }
    .tabs-container{
      background: #354051;
      @media only screen and (max-width: 992px) {
        margin-top: 30px;
        border-radius: 4px;
      }
      @media only screen and (max-width: 767px) {
        margin-top: 0;
        
      }
      .indicator{
        background-color: #414d60;
      }
    }
  }
 
  .notification-tabs{
    background: transparent;
    .notification-tabs-item{
      height: 47px;
      @media only screen and (max-width: 767px) {
        height: 40px;
      }
    }
  }
}
  
</style>